import React from 'react';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const modalStyle = {
  backgroundColor: '#fff',
  padding: '24px 28px',
  borderRadius: '12px',
  minWidth: '320px',
  maxWidth: '90%',
  boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2)',
};

const headerStyle = {
  margin: '0 0 16px',
  fontSize: '20px',
  fontWeight: '600',
  textAlign: 'center',
  color: '#333',
  textTransform: 'capitalize',
};

const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: '6px',
  border: '1px solid #ccc',
  fontSize: '16px',
  boxSizing: 'border-box',
  marginBottom: '12px',
};

const errorStyle = {
  color: '#c0392b',
  fontSize: '14px',
  marginBottom: '12px',
  textAlign: 'center',
};

const actionStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '12px',
};

const PasswordPrompt = ({
  isOpen,
  title = 'Password Required',
  password,
  onPasswordChange,
  onConfirm,
  onCancel,
  error,
  isSubmitting = false,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3 style={headerStyle}>{title}</h3>
        <input
          type="password"
          value={password}
          onChange={(event) => onPasswordChange(event.target.value)}
          style={inputStyle}
          placeholder="Enter password"
          autoFocus
          disabled={isSubmitting}
        />
        {error && <div style={errorStyle}>{error}</div>}
        <div style={actionStyle}>
          <button
            type="button"
            className="Capt"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="Capt"
            onClick={onConfirm}
            disabled={isSubmitting || !password}
          >
            {isSubmitting ? 'Saving...' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordPrompt;

